var CalendarsSyncCtrl = function(
  $scope,
  $state,
  $window,
  $q,
  $timeout,
  $uibModal,
  AppointmentModel,
  googleSync,
  calDavProviders,
  calDavServices,
  CalDavDA,
  SyncDA,
  ResourceDA,
  AppointmentDA,
  Notification,
  GoogleSyncDA,
  gettextCatalog,
  resources,
  SoftPlusSyncDA,
  softPlusUser,
) {
  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
  this._AppointmentModel = AppointmentModel;
  this._Notification = Notification;
  this._GoogleSyncDA = GoogleSyncDA;
  this._window = $window;
  this.gettextCatalog = gettextCatalog;
  this.resources = resources;
  this.responseError = false;
  this.providers = calDavProviders;
  $scope.resource = resources[0] || {};
  this.serviceGroups = calDavServices.serviceGroups || [];
  this.linkedServices = calDavServices.linkedServices || [];
  this.showCalDavLinkingPage = false;

  var self = this;
  var isCalDavProviderExists = this.providers.caldav_providers.length;

  this.serviceGroups.forEach(function(serviceGroup) {
    serviceGroup.services.forEach(function(service) {
      service.calendar_name = self.linkedServices[service._id] || null;

      self.showCalDavLinkingPage = self.showCalDavLinkingPage || !!service.calendar_name;
    });
  });

  self.showCalDavLinkingPage = isCalDavProviderExists && self.showCalDavLinkingPage;
  self.showSyncCalDav = self.showCalDavLinkingPage;

  this.registerCalDav = function() {
    var modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'app/modules/calendars-sync/CalDavRegisterView.html?v=4.5.6',
      controller: 'CalDavRegisterView',
      size: 'md',
    });

    return modalInstance.result.then(
      function(calDavCredentials) {
        CalDavDA.registerCalDav(calDavCredentials)
          .then(function(response) {
            if (!response.success) return $q.reject(response);

            return CalDavDA.getList();
          })
          .then(function(response) {
            if (!response.success) return $q.reject(response);

            self.providers = response.providers;

            Notification.addSuccessMessage(
              self.gettextCatalog.getString('Registered successfully'),
            );
          })
          .then(function() {
            self.providers.caldav_providers.forEach(function(provider) {
              self.discoverCalDav(provider);
            });
          })
          .catch(function(error) {
            Notification.addErrorMessage(
              self.gettextCatalog.getString('Registration failed: {{error}}', {
                error: error.error,
              }),
            );
            console.error(error);
          });
      },
      function(dismiss) {
        console.log(dismiss);
      },
    );
  };

  //#region SoftPLUS

  // check if softPLUS user is syncing
  if (softPlusUser && softPlusUser._id) {
    const { _id: id, userGln, companyGln } = softPlusUser;

    self.providers.softPlus = {
      id,
      userGln,
      companyGln,
    };
  }

  this.registerSoftPlus = async () => {
    try {
      const response = await SoftPlusSyncDA.sync({ companyGln: undefined });

      if (!response.registeredUser && response.hasMultipleCompanyGLN) {
        const modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/modules/calendars-sync/SoftPlusSelectCompanyGlnView.html?v=4.5.6',
          controller: 'SoftPlusSelectCompanyGlnView',
          size: 'md',
          resolve: {
            companyGlns() {
              return response.companyGLNs;
            },
          },
        });

        // save SoftPLUS Credentials to DB when modalInstance promise returns the result
        return modalInstance.result.then(
          async ({ companyGln }) => {
            try {
              const response = await SoftPlusSyncDA.sync({ companyGln });

              const {
                companyGln: registeredCompanyGln,
                _id: id,
                userGln,
              } = response.registeredUser;

              self.providers.softPlus = {
                id,
                userGln,
                companyGln: registeredCompanyGln,
              };

              Notification.addSuccessMessage(
                self.gettextCatalog.getString('Registered successfully'),
              );
            } catch (error) {
              const { data } = error;
              Notification.addErrorMessage(
                gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
                  error: data && data.error && data.error.error ? data.error.error.msg : error,
                }),
              );
            }
            // save SoftPLUS Credentials to DB
          },
          dismiss => {
            console.log(dismiss);
          },
        );
      } else {
        const { companyGln: registeredCompanyGln, _id: id, userGln } = response.registeredUser;

        self.providers.softPlus = {
          id,
          userGln,
          companyGln: registeredCompanyGln,
        };
        return true;
      }
    } catch (error) {
      const { data } = error;
      Notification.addErrorMessage(
        gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
          error: data && data.error && data.error.error ? data.error.error.msg : error,
        }),
      );
    }
  };

  // Disconnect from SoftPLUS
  this.disconnectSoftPlus = async () => {
    try {
      await SoftPlusSyncDA.removeSync();

      self.providers.softPlus = null;

      Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from SoftPlus'));

      self.reload();
    } catch (error) {
      const { data } = error;
      Notification.addErrorMessage(
        self.gettextCatalog.getString('Disconnect failed: {{error}}', {
          error: data && data.error && data.error.error ? data.error.error.msg : error,
        }),
      );
    }
  };

  this.syncSoftPLusAppointments = async () => {
    try {
      self.providers.softPlus.loading = true;
      await SoftPlusSyncDA.syncSoftPLusAppointments();
      self.providers.softPlus.loading = false;

      Notification.addSuccessMessage(
        self.gettextCatalog.getString('Appointments synced from SoftPlus'),
      );

      // self.reload();
    } catch (error) {
      self.providers.softPlus.loading = false;
      const { data } = error;
      Notification.addErrorMessage(
        self.gettextCatalog.getString('Sync failed: {{error}}', {
          error: data && data.error && data.error.error ? data.error.error.msg : error,
        }),
      );
    }
  };
  //#endregion

  this.globalCalDavCalendar = '';
  this.changeGlobalCalDavCalendar = function() {
    this.serviceGroups.forEach(function(serviceGroup) {
      serviceGroup.services.forEach(function(service) {
        service.calendar_name = self.globalCalDavCalendar;
      });
    });
  };

  this.discoverCalDav = function() {
    var provider = _.get(self, 'providers.caldav_providers[0]');

    if (!provider) return;

    CalDavDA.discoverProvider(provider.name)
      .then(function(response) {
        response.forEach(function(calendar) {
          calendar.value = true;
        });
        provider.calendars = response;
      })
      .catch(function(error) {
        console.error(error);
      });
  };

  this.updateCalDavCalendars = function() {
    var provider = _.get(self, 'providers.caldav_providers[0]');

    if (!provider) return;

    CalDavDA.getDiscoveredCalendars(provider.name)
      .then(function(response) {
        response.forEach(function(calendar) {
          calendar.value = true;
        });
        provider.calendars = response;
      })
      .catch(function(error) {
        console.error(error);
      });
  };

  this.linkServicesWithCalDav = function() {
    var promises = [];
    var providerCalendars = self.getDiscoveredCalDavCalendars() || [];
    var calendarsToRemove = providerCalendars.reduce(function(result, calendar) {
      if (!calendar.value) {
        result.push(calendar.url);
      }

      return result;
    }, []);

    if (calendarsToRemove.length) {
      promises.push(CalDavDA.removeCalendars(calendarsToRemove));
    }

    self.serviceGroups.forEach(function(serviceGroup) {
      serviceGroup.services.forEach(function(service) {
        if (service.calendar_name && service.calendar_name !== self.linkedServices[service._id]) {
          promises.push(CalDavDA.linkService(service._id, service.calendar_name));
        }

        if (!service.calendar_name && self.linkedServices[service._id]) {
          promises.push(CalDavDA.unlinkService(service._id));
        }
      });
    });

    $q.all(promises).then(function() {
      self.updateCalDavCalendars();

      Notification.addSuccessMessage(self.gettextCatalog.getString('Linked successfully!'));

      self.showSyncCalDav = true;
    });
  };

  this.changeCalDavOptions = function() {
    self.showSyncCalDav = false;
    self.globalCalDavCalendar = '';
  };

  this.syncCalDav = function() {
    CalDavDA.sync().then(function() {
      Notification.addSuccessMessage(self.gettextCatalog.getString('Sync process was started!'));
    });
  };

  this.getDiscoveredCalDavCalendars = function() {
    return _.get(self, 'providers.caldav_providers[0].calendars');
  };

  this.getActiveCalDavCalendars = function() {
    var calendars = self.getDiscoveredCalDavCalendars() || [];
    return calendars.filter(function(calendar) {
      return calendar.value;
    });
  };

  this.toCalDavLinking = function() {
    var providerCalendars = self.getDiscoveredCalDavCalendars();

    if (!providerCalendars || !providerCalendars.length) {
      return Notification.addErrorMessage(
        self.gettextCatalog.getString('Please discover your calendars first'),
      );
    }

    var isSelected = providerCalendars.some(function(calendar) {
      return calendar.value;
    });

    if (!isSelected) {
      return Notification.addErrorMessage(
        self.gettextCatalog.getString('Please select at least one calendar'),
      );
    }

    self.showCalDavLinkingPage = true;
  };

  this.disconnectCalDav = function(provider) {
    CalDavDA.disconnectProvider(provider.name)
      .then(function() {
        var index = self.providers.caldav_providers.indexOf(provider);

        self.providers.caldav_providers.splice(index, 1);

        Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected successfully'));
      })
      .catch(function(error) {
        console.error(error);
      });
  };

  if (this.providers.google) {
    CalDavDA.discoverProvider('google')
      .then(function(response) {
        self.googleCalendars = response;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  if (this.providers.outlook) {
    CalDavDA.discoverProvider('outlook')
      .then(function(response) {
        self.outlookCalendars = response;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  this.disconnectGoogle = function() {
    CalDavDA.disconnectProvider('google')
      .then(function() {
        Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from Google'));
        self.reload();
      })
      .catch(function(error) {
        Notification.addErrorMessage(
          self.gettextCatalog.getString('Disconnect failed: {{error}}', { error: error.error }),
        );
        console.error(error);
      });
  };

  this.disconnectOutlook = function() {
    CalDavDA.disconnectProvider('outlook')
      .then(function() {
        Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from Outlook'));
        self.reload();
      })
      .catch(function(error) {
        Notification.addErrorMessage(
          self.gettextCatalog.getString('Disconnect failed: {{error}}', { error: error.error }),
        );
        console.error(error);
      });
  };

  this.sync = {};
  var checkTimeout;
  this.checkOnGoogleSyncPending = function(forceUpdate) {
    if (!self.sync.googleMappingPending && !forceUpdate) return $q.resolve();

    return self._GoogleSyncDA.getCalendarList().then(function(googleSync) {
      self.sync = googleSync.sync || {};
      self.sync.googleMapping = self.sync.googleMapping || {};

      if (!self.sync.googleMappingPending) return $q.resolve();

      self.sync.googleMapping = self.sync.tmpGoogleMapping || self.sync.googleMapping;

      checkTimeout = $timeout(self.checkOnGoogleSyncPending, 5000);

      return checkTimeout;
    });
  };

  if (!googleSync) {
    this.responseError = true;
  } else if (googleSync.success === false) {
    this.responseError = true;
  } else {
    this.sync = googleSync.sync || {};
    this.sync.googleMapping = this.sync.googleMapping || {};
    this.calendarList = googleSync.payload;

    this.calendarList.forEach(function(calendar) {
      calendar.id = calendar.id.replace(/\./g, '__');
    });

    this.checkOnGoogleSyncPending();
  }

  $scope.$on('$destroy', function() {
    $timeout.cancel(checkTimeout);
  });

  this.reload = function() {
    $state.reload();
  };

  // iCal sync section

  /**
   * generate private calendar address
   */
  var generateCalendarAddress = function() {
    var base =
      location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

    if ($scope.resource._id && $scope.resource.ical) {
      $scope.icalUrl = base + '/api/v2/calendar/ical/' + $scope.resource.ical + '/feed.ics';
    }
  };

  var loadSyncs = function() {
    if ($scope.resource._id) {
      SyncDA.get($scope.resource._id).then(function(response) {
        $scope.syncs = response.syncList;
      });
    }
  };

  if ($scope.resource.ical) {
    $scope.privateCalendarAddressEnabled = true;
    generateCalendarAddress();
  }

  loadSyncs();

  /**
   * enable/disable private calendar address
   */
  $scope.changePrivateCalendarAddressEnabledState = function() {
    if ($scope.privateCalendarAddressEnabled) {
      $scope.resetPrivateAddress();
    } else {
      $scope.resource.ical = null;
      $scope.icalUrl = '';
    }
  };

  /**
   * get new private calendar address from API
   */
  $scope.resetPrivateAddress = function() {
    ResourceDA.refreshCalendarAddress($scope.resource._id)
      .then(function(response) {
        $scope.resource.ical = response.ical;
        generateCalendarAddress();
        Notification.addSuccessMessage(gettextCatalog.getString('calendar address resetted'));
      })
      .catch(function() {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant reset private calendar address'),
        );
      });
  };

  /**
   * add new external calendar
   */
  $scope.addCalendarUrl = function() {
    var syncAlreadyExists = $scope.syncs.filter(function(sync) {
      return sync.address === $scope.externalIcalAddress;
    })[0];

    if (syncAlreadyExists) {
      return Notification.addErrorMessage(
        gettextCatalog.getString('You cant subscribe to same calendar twice'),
      );
    }

    if ($scope.icalUrl === $scope.externalIcalAddress) {
      return Notification.addErrorMessage(
        gettextCatalog.getString('You cant subscribe to your own calendar in this system'),
      );
    }

    var calendarSync = {
      type: 'ical',
      address: $scope.externalIcalAddress,
      copyDescription: $scope.copyDescription,
    };

    SyncDA.insert($scope.resource._id, calendarSync).then(
      function(response) {
        $scope.externalIcalAddress = '';
        $scope.syncs.push(response.sync);
        Notification.addSuccessMessage(
          gettextCatalog.getString('Successfully subscribed to calendar'),
        );
      },
      // TODO: implement a helper function or a global error handler
      function(response) {
        var errorMsg = _.get(response, 'data.error[0].msg');
        var error;

        if (errorMsg) {
          error = gettextCatalog.getString(errorMsg);
        } else {
          error = gettextCatalog.getString('Unknown');
        }

        Notification.addErrorMessage(
          gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  };

  function _removeSync(sync) {
    return SyncDA.delete($scope.resource._id, sync._id).then(
      function() {
        var index = $scope.syncs.indexOf(sync);
        $scope.syncs.splice(index, 1);
        Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription removed'));
      },
      function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant remove calendar subscription (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  }

  $scope.updateSyncActive = function(sync) {
    return SyncDA.update($scope.resource._id, sync._id, sync).then(
      function(updatedSync) {
        var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
        syncToUpdate.active = updatedSync.active;

        if (!syncToUpdate.active) {
          Notification.addInfoMessage(
            gettextCatalog.getString('You still can sync your calendar manually'),
          );
          Notification.addSuccessMessage(
            gettextCatalog.getString('Calendar subscription disabled'),
          );
        } else {
          Notification.addInfoMessage(
            gettextCatalog.getString(
              'Calendar events will be synced with this calendar automatically',
            ),
          );
          Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription enabled'));
        }
      },
      function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  };

  $scope.updateSyncIsCopyDescription = function(sync) {
    return SyncDA.update($scope.resource._id, sync._id, sync).then(
      function(updatedSync) {
        var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
        syncToUpdate.copyDescription = updatedSync.copyDescription;

        if (!syncToUpdate.copyDescription) {
          Notification.addInfoMessage(
            gettextCatalog.getString('Copy Appointment Description disabled'),
          );
        } else {
          Notification.addInfoMessage(
            gettextCatalog.getString('Copy Appointment Description enabled'),
          );
        }
      },
      function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  };

  $scope.removeSync = function(sync) {
    if (!sync.lastSync) return _removeSync(sync);

    if ($scope.isPending(sync)) return;

    var cond = confirm(gettextCatalog.getString('Do you want to remove all related events too?'));

    if (!cond && !sync.active) return;

    if (!cond) {
      var updatedSync = _.cloneDeep(sync);
      updatedSync.active = false;

      return $scope.updateSyncActive(updatedSync);
    }

    AppointmentDA.removeSyncedViaICal($scope.resource._id, sync._id).then(function(res) {
      if (!res.success) return new Error('Cant remove associated appointments');

      Notification.addSuccessMessage(gettextCatalog.getString('Related events removed'));

      return _removeSync(sync);
    });
  };

  $scope.isPending = function(sync) {
    var date = sync && sync.lastSync;

    if (!date || sync.error > 0) return false;

    return new Date(date).valueOf() === -1;
  };

  var pendingTimeout;
  function checkPending() {
    var isNeedToRefresh =
      !$scope.syncs ||
      $scope.syncs.some(function(item) {
        return $scope.isPending(item);
      });

    if ($scope.resource._id && !isNeedToRefresh) return;

    SyncDA.get($scope.resource._id).then(function(response) {
      $scope.syncs = response.syncList;

      pendingTimeout = $timeout(checkPending, 10000);
    });
  }

  checkPending();

  $scope.$on('$destroy', function() {
    $timeout.cancel(pendingTimeout);
  });

  $scope.runSync = function(sync) {
    if ($scope.isPending(sync)) return;

    Notification.addSuccessMessage(
      gettextCatalog.getString('Please wait, calendar sync can take some time'),
    );

    sync.lastSync = new Date(-1);
    sync.error = 0;

    SyncDA.runSync($scope.resource._id, sync._id).then(
      function(updatedSync) {
        sync.lastSync = updatedSync.lastSync;
        var count = updatedSync.count;
        var message;

        if (count) {
          message =
            count > 1
              ? gettextCatalog.getString('Was added {{count}} appointments', { count: count })
              : gettextCatalog.getString('Was added one appointment');

          Notification.addSuccessMessage(message);
        }

        Notification.addSuccessMessage(gettextCatalog.getString('Calendar is synced'));
      },
      function(resource) {
        checkPending();

        var errorMsg = _.get(resource, 'data.error');

        if (errorMsg) {
          errorMsg = gettextCatalog.getString(errorMsg);
        } else {
          errorMsg = gettextCatalog.getString('Unknown');
        }

        Notification.addErrorMessage(
          gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
            error: errorMsg,
          }),
        );
      },
    );
  };

  this.selectDefaultGoogleCalendar = () => {
    if (angular.equals(self.sync.googleMapping, {})) {
      self.calendarList.forEach(({ isAutoGeneratedCalendar, id }) => {
        if (isAutoGeneratedCalendar) {
          self.sync.googleMapping[id] = {
            resource: self.resources[0].id,
          };
        }
      });
    }
  };
  this.selectDefaultGoogleCalendar();
};

/**
 *  speichere mappings
 *
 *  funktion implementieren die checkt ob es einen change gab
 *  initales laden der calendar
 */

CalendarsSyncCtrl.prototype.connect = function() {
  this._window.open(
    '/api/v2/auth/google',
    'google_auth',
    'width=450, height=500, scrolling=yes, resizable=no',
  );

  var self = this;
  window.authWindowClose = function() {
    self.reload();
  };
};

CalendarsSyncCtrl.prototype.registerGoogle = function() {
  this._window.open(
    '/api/v2/calendarApi/register/oauth/google',
    'google_auth',
    'width=450, height=500, scrolling=yes, resizable=no',
  );

  var self = this;
  window.closeOnAuthSuccess = function() {
    self.reload();
  };
};

CalendarsSyncCtrl.prototype.registerOutlook = function() {
  this._window.open(
    '/api/v2/calendarApi/register/oauth/outlook',
    'google_auth',
    'width=450, height=500, scrolling=yes, resizable=no',
  );

  var self = this;
  window.closeOnAuthSuccess = function() {
    self.reload();
  };
};

CalendarsSyncCtrl.prototype.disconnect = function() {
  var self = this;

  this._GoogleSyncDA.revokeAccess().then(
    function() {
      self.calendarList = [];
      self.responseError = true;
      self._AppointmentModel.clearCache();
      self._Notification.addSuccessMessage(
        self.gettextCatalog.getString('Disconnected from Google'),
      );
    },
    function(error) {
      self._Notification.addErrorMessage({ text: error });
    },
  );
};

CalendarsSyncCtrl.prototype.save = function() {
  var self = this;

  self._GoogleSyncDA.update(this.sync).then(
    function(updatedSync) {
      self.sync = updatedSync.sync || {};

      if (self.sync.googleMappingPending) {
        self._Notification.addInfoMessage(
          self.gettextCatalog.getString('Calendar mapping will be updated after this process'),
        );
        self._Notification.addSuccessMessage(
          self.gettextCatalog.getString('Please wait, calendar synchronisation in progress'),
        );
      }

      self.checkOnGoogleSyncPending().then(function() {
        self._Notification.addSuccessMessage(
          self.gettextCatalog.getString('Calendar mapping saved'),
        );
      });

      self._AppointmentModel.clearCache();
    },
    function(error) {
      var errorMessage = _.get(error, 'data.error.errors[0].message');
      errorMessage = errorMessage || _.get(error, 'data.error[0].message');
      errorMessage = errorMessage || _.get(error, 'data.error.message');
      errorMessage = errorMessage || _.get(error, 'data.error');
      errorMessage = errorMessage || error;

      self._Notification.addErrorMessage({ text: errorMessage });

      self.checkOnGoogleSyncPending(true);
    },
  );
};

CalendarsSyncCtrl.prototype.resourceChanged = function(calendarId) {
  delete this.sync.googleMapping[calendarId].primary;
};

CalendarsSyncCtrl.prototype.checkPrimary = function(calendarId) {
  var mappings = this.sync.googleMapping;
  var checkMapping = mappings[calendarId];

  if (checkMapping) {
    var resource = mappings[calendarId].resource;

    _.forEach(mappings, function(mapping, key) {
      if (key !== calendarId && mapping.resource === resource) {
        delete mapping.primary;
      }
    });
  }
};

module.exports = CalendarsSyncCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/calendars-sync/CalendarsSyncCtrl.js